<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 600px">
      <div class="card-header">
        <h1>Append Components</h1>
        <p>Enter the components you want to add into the textbox below</p>
      </div>
      <form class="card-body" @submit.prevent="attemptPublish">
        <div class="form-group">
          <label for="name" class="form-label">Components (seperate by new line)</label>
          <textarea id="name" type="text" name="name" ref="name" class="form-control" v-model="text"
            placeholder="First Name" autocomplete="off" data-lpignore="true" data-form-type="other"
            @input="handleResizeTextarea" />
        </div>
      </form>
      <div class="card-footer">
        <button class="button primary" @click.prevent="attemptAppend">
          Append Components
        </button>
        <p class="error" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppendComponentsModal",
  data() {
    return {
      text: "",
      error: "",
    };
  },
  methods: {
    attemptAppend() {
      const lines = this.text.split('\n');
      const components = lines.map(line => this.createComponentForLine(line))
      this.$emit('appendComponents', components)
    },
    handleResizeTextarea(event) {
      const textarea = event.target;
      textarea.style.height = '0px';
      textarea.style.height = `${textarea.scrollHeight}px`
    },
    generateRandomNonce(length = 10) {
      let id = "";
      for (let i = 0; i < length; i++) {
        id += Math.floor(Math.random() * 10);
      }
      return id;
    },
    createComponentForLine(line) {
      const nonce = this.generateRandomNonce();
      let type = 'TEXT';
      let label = line;
      let component = {
        key: `doNotImport${nonce}`
      };

      // Match leading hashes for headers and paragraph
      const headerMatch = line.match(/^(#+)\s*(.*)/);
      if (headerMatch) {
        const hashCount = headerMatch[1].length;
        label = headerMatch[2].trim();

        if (hashCount === 1) {
          type = 'HEADER';
          component.headerSize = 'h1';
        } else if (hashCount === 2) {
          type = 'HEADER';
          component.headerSize = 'h2';
        } else if (hashCount === 3) {
          type = 'HEADER';
          component.headerSize = 'h3';
        } else if (hashCount >= 4) {
          type = 'PARAGRAPH';
        }
      }

      // Match suffix dropdown options like: ["Option 1", "Option 2"]
      const dropdownMatch = label.match(/^(.*)\[\s*"([^"]+)"(?:\s*,\s*"([^"]+)")*\s*]/);
      if (dropdownMatch) {
        const allOptions = [];
        const optionRegex = /"([^"]+)"/g;
        let match;
        while ((match = optionRegex.exec(label)) !== null) {
          allOptions.push(match[1]);
        }

        type = 'DROPDOWN';
        label = label.replace(/\[\s*".*?"(?:\s*,\s*".*?")*\s*]$/, '').trim();
        component.options = allOptions;
      }

      component.label = label;
      component.type = type;

      return component;
    },
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
  },
  emits: ["closeModal", "appendComponents"],
};
</script>

<style scoped>
textarea {
  min-height: 126px;
}
</style>